import type { RESTPostOAuth2AccessTokenResult } from "discord-api-types/v10";

import Endpoints = require("./Endpoints");














async function getOauth2Token(clientId: string, redirectURI: string, clientSecret: string, code: string): Promise<RESTPostOAuth2AccessTokenResult> {
	const response = await fetch(`${Endpoints.BASE_HOST}${Endpoints.OAUTH2_TOKEN}`, {
		method: "POST",
		body: new URLSearchParams({
			grant_type: "authorization_code",
			code,
			client_id: clientId,
			client_secret: clientSecret,
			redirect_uri: redirectURI
		})
	});
	return response.json() as Promise<RESTPostOAuth2AccessTokenResult>;
}

export = {
	getOauth2Token
}
